import { Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { useColumns } from './hooks/useColumns';
import { StudentsRemovalRequestItemPending } from '../types';
import TableEmptyContent from '../../../../components/text/TableEmptyContent';
import { useStudentsRemovalRequestsPendingtList } from './StudentsRemovalRequestsPendingListLoader';

export interface StudentsRemovalRequestsPendingTableProps {
  data: StudentsRemovalRequestItemPending[];
  loading: boolean;
}

export function StudentsRemovalRequestsPendingTable({
  data,
  loading,
}: StudentsRemovalRequestsPendingTableProps) {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT_PENDING,
  );

  const { query } = useStudentsRemovalRequestsPendingtList();

  const texts = useMemo(() => {
    return t<
      string,
      {
        empty: {
          noResults: {
            title: string;
            body: string;
          };
          noSearch: {
            title: string;
            body: string;
          };
        };
      }
    >('requests-pending.table', {
      returnObjects: true,
    });
  }, [t]);

  const textsEmpty = useMemo(() => {
    if (!query.studentNameOrId && !query.studyPlanVersionId) {
      return texts.empty.noSearch;
    }
    return texts.empty.noResults;
  }, [texts, query]);

  const columns = useColumns();

  return (
    <Table
      columns={columns}
      data={data}
      isLoadingResults={loading}
      noResultsText={
        <TableEmptyContent
          title={textsEmpty.title}
          subtitle={textsEmpty.body}
        />
      }
    />
  );
}
